import React from "react";
import Icon from '@mdi/react';
import { mdiCloseCircle } from '@mdi/js';
import { Button, Space } from "antd";


export default function InvalidReferralLink(){
  return (
    <div id="invalid-referral-link" className="error-page">
      <h1>Page Not Found</h1>
      <Space size={8} direction="vertical"  align="center">
        <p> <Icon path={mdiCloseCircle} size="38px" /> &nbsp; Link no longer valid </p>
        <span>The referral link is no longer valid, please select another product.</span>
      </Space>
      <Button href="/web" color="primary" variant="solid">back to home</Button>
    </div>
  )
}